import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M11.7177 4.63367L10.7953 4.43317C10.7151 4.18762 10.6158 3.94812 10.4985 3.71741L11.0091 2.92319C11.1003 2.78128 11.0803 2.59497 10.9611 2.47577L9.52423 1.03894C9.40503 0.919739 9.21872 0.899689 9.07681 0.990875L8.28259 1.50146C8.05188 1.38419 7.81238 1.28485 7.56683 1.20465L7.36633 0.282349C7.33054 0.117554 7.1846 0 7.01596 0H4.98404C4.8154 0 4.66946 0.117554 4.63367 0.282349L4.43317 1.20465C4.18762 1.28485 3.94812 1.38419 3.71741 1.50146L2.92319 0.990875C2.78128 0.899689 2.59497 0.919739 2.47577 1.03894L1.03894 2.47577C0.919739 2.59497 0.899689 2.78128 0.990875 2.92319L1.50146 3.71741C1.38419 3.94812 1.28485 4.18762 1.20465 4.43317L0.282349 4.63367C0.117554 4.66956 0 4.8154 0 4.98404V7.01596C0 7.1846 0.117554 7.33044 0.282349 7.36633L1.20465 7.56683C1.28485 7.81238 1.38419 8.05188 1.50146 8.28259L0.990875 9.07681C0.899689 9.21872 0.919739 9.40503 1.03894 9.52423L2.47577 10.9611C2.59497 11.0803 2.78128 11.1003 2.92319 11.0091L3.71741 10.4985C3.94812 10.6158 4.18762 10.7151 4.43317 10.7953L4.63367 11.7177C4.66946 11.8824 4.8154 12 4.98404 12H7.01596C7.1846 12 7.33054 11.8824 7.36633 11.7177L7.56683 10.7953C7.81238 10.7151 8.05188 10.6158 8.28259 10.4985L9.07681 11.0091C9.21872 11.1003 9.40503 11.0804 9.52423 10.9611L10.9611 9.52423C11.0803 9.40503 11.1003 9.21872 11.0091 9.07681L10.4985 8.28259C10.6158 8.05188 10.7151 7.81238 10.7953 7.56683L11.7177 7.36633C11.8824 7.33044 12 7.1846 12 7.01596V4.98404C12 4.8154 11.8824 4.66956 11.7177 4.63367V4.63367ZM8.1514 6C8.1514 7.18625 7.18625 8.1514 6 8.1514C4.81375 8.1514 3.8486 7.18625 3.8486 6C3.8486 4.81375 4.81375 3.8486 6 3.8486C7.18625 3.8486 8.1514 4.81375 8.1514 6V6Z"
          fill="#D8DFE0"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default memo(Icon);
